<div class="container">
    <div class="row mt-4">
        <div class="col-8">
            <h4>Lista de Usuarios</h4>
        </div>
        <div class="col-4 text-right">
            <button class="btn btn-primary col-6" (click)="newUser()" *ngIf="adm">Novo</button>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">CWID</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Email</th>
                        <th scope="col">Perfil</th>
                        <th class="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listUser">
                        <td>{{item.cwid}}</td>
                        <td>{{item.user_name}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.admin ? "Administrador" :"Gestor"}}</td>
                        <td class="text-center">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">

                                <button *ngIf="adm" mat-button color="primary" class="w-100" matTooltip="Editar Usuário"
                                    (click)="edit(item.id)">
                                    <i class="fa fa-edit fa-1x btnIcon"></i>
                                    Editar Usuário
                                </button>

                                <button *ngIf="adm" mat-button color="primary" class="w-100" matTooltip="Apagar Usuário"
                                    (click)="deleteUser(item.id)">
                                    <i class="fa fa-trash fa-1x btnIcon"></i>
                                    Apagar Usuário
                                </button>

                            </mat-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="col-12 text-center" *ngIf="listUser.length === 0 && adm == true">
                <label for="">Nenhum registro encontrado</label>
            </div>
            <div class="col-12 text-center" *ngIf="listUser.length === 0 && adm == false">
                <label for="">Você não tem permissão</label>
            </div>
        </div>
    </div>
</div>